import { Typography, Grid, Paper, Stack } from "@mui/material";
import React from "react";
import { CustomerDetailInterface } from "../../Objects/Customer";

export interface CustomerMemoProps {
    customerData: CustomerDetailInterface
}

const CustomerMemo: React.FC<CustomerMemoProps> = ({
    customerData
}) => {
    return (
        <>
            {customerData.ctm_memo &&
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{color: "#333399"}}>メモ</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack
                            spacing={1}
                        >
                            {Object.values(customerData.ctm_memo).map( (value, index) => (
                                <Paper key={index}
                                    variant="outlined"
                                    sx={{
                                        p: 1,
                                    }}
                                >
                                    <Typography variant="body2">{value}</Typography>
                                </Paper>
                            ))}
                        </Stack>
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default CustomerMemo